import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "text-bold" }, "ENTER", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_input = _resolveComponent("q-input")

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _ctx.tel,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tel = $event)),
    "bottom-slots": true,
    "label-slot": true,
    dense: true,
    autofocus: _ctx.autofocus,
    type: "tel",
    color: "primary",
    onKeyup: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.inputValue()), ["prevent"]), ["enter"]))
  }, _createSlots({
    label: _withCtx(() => [
      _createVNode("span", null, _toDisplayString(_ctx.$t('widgetYourPhoneNumber')), 1)
    ]),
    _: 2
  }, [
    (_ctx.$q.screen.name !== 'xs')
      ? {
          name: "counter",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('widgetClick')) + " ", 1 /* TEXT */),
            _hoisted_1
          ])
        }
      : undefined,
    (_ctx.tel)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "send",
              flat: true,
              dense: true,
              round: true,
              color: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue()))
            })
          ])
        }
      : undefined
  ]), 1032, ["modelValue", "autofocus"]))
}